import { getConditionalObject } from 'utils/data';

export const toDrawerEntityField = ({ field, formPath, isDisabled }) => ({
  ...field,
  nameInModel: `${formPath}.${field.nameInModel}`,
  ...getConditionalObject(isDisabled, () => ({
    inputProps: { ...field.inputProps, disabled: true },
  })),
});

export const flattenGroupFields = groups => groups.flatMap(group => group.fields);

export const checkIsEntityAvailable = entityContext =>
  !!entityContext?.isEnabled && !!entityContext.isViewAllowed;
